
import { Box, useTheme, } from "@mui/material";
import { DEFAULT_QUESTION } from "../../../components/Questionnaire/constants";
import QuestionnaireQuestionSection from "../../../components/Questionnaire/QuestionnaireQuestionSection";
import { useTranslation } from "react-i18next";

const QuestionnaireQuestionForm = ({ sections, setSections, activeToolbarKey, setActiveToolbarKey, questionFormErrors, setQuestionFormErrors, isReadOnly }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const updateSectionTitle = (sectionIndex, patch) => {
    setSections(prev =>
      prev.map((sec, i) => (i === sectionIndex ? { ...sec, ...patch } : sec))
    );
    setQuestionFormErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[`${sectionIndex}`];
      return newErrors;
    });
  };

  const updateQuestion = (sectionIndex, questionIndex, patch) => {
    setSections(prev =>
      prev.map((sec, i) =>
        i === sectionIndex
          ? {
            ...sec,
            questions: sec.questions.map((q, qi) =>
              qi === questionIndex ? { ...q, ...patch } : q
            ),
          }
          : sec
      )
    );
    setQuestionFormErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[`${sectionIndex}-${questionIndex}`];
      return newErrors;
    });
  };



  const handleAddQuestion = (e, data) => {
    e.stopPropagation();

    const newQuestion = {
      ...DEFAULT_QUESTION.questions[0],
      options: [{ option: t("questionnaire.form.optionWithNo", { number: 1 }) }],
    };

    setSections(prev =>
      prev.map((sec, i) => {
        if (i === data.sectionIndex) {
          let newQuestions = [...sec.questions];
          let newQuestionIndex = sec.questions.length;

          if (data.questionIndex !== undefined && data.questionIndex !== null) {
            newQuestionIndex = data.questionIndex + 1;
            newQuestions.splice(newQuestionIndex, 0, newQuestion);
          } else {
            newQuestions.push(newQuestion);
          }

          setActiveToolbarKey(`${data.sectionIndex}-${newQuestionIndex}`);

          return {
            ...sec,
            questions: newQuestions,
          };
        }
        return sec;
      })
    );
  };
  console.log('activeToolbarKey', activeToolbarKey)
  return (
    <Box
      sx={{
        bgcolor: theme.palette.grey[100],
        minHeight: "100%",
        display: "flex",
        justifyContent: "center",
        position: "relative",
        pointerEvents: isReadOnly ? "none" : "auto",
        opacity: isReadOnly ? 0.7 : 1,
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 700, mt: 4 }}>
        {sections?.map((section, sectionIndex) => (
          <QuestionnaireQuestionSection
            key={sectionIndex}
            activeToolbarKey={activeToolbarKey}
            setActiveToolbarKey={setActiveToolbarKey}
            section={section}
            sectionIndex={sectionIndex}
            totalSections={sections.length}
            updateSectionTitle={updateSectionTitle}
            updateQuestion={updateQuestion}
            setSections={setSections}
            handleAddQuestion={handleAddQuestion}
            questionFormErrors={questionFormErrors}
          />
        ))}
      </Box>
    </Box>
  );
};

export default QuestionnaireQuestionForm;
